export const SET_TWITCH_CONTEXT = 'SET_TWITCH_CONTEXT'
export const SET_TWITCH_AUTH = 'SET_TWITCH_AUTH'
export const SET_TWITCH_FEATURES = 'SET_TWITCH_FEATURES'
export const SET_TWITCH_PRODUCTS = 'SET_TWITCH_PRODUCTS'
